import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import ToggleButtons from '@/components/buttons/ToggleButtons.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import Option from './types/Option.ts';

const ToggleInput = <TFieldValues extends FieldValues>({
  fieldPath,
  label,
  required = false,
  hint,
  options,
  control,
  error,
  onChange,
}: {
  fieldPath: Path<TFieldValues>;
  label: string;
  required?: boolean;
  hint?: string;
  options: Option[];
  control: Control<TFieldValues>;
  error?: string;
  onChange?: (value: string) => void;
}) => {
  return (
    <div className="flex flex-col">
      <Controller
        control={control}
        name={fieldPath}
        render={({ field }) => (
          <ToggleButtons
            label={label}
            required={required}
            options={options}
            selected={field.value}
            onChange={(value) => {
              field.onChange(value);
              if (onChange) {
                onChange(value);
              }
            }}
            hint={hint}
          />
        )}
      />
      {error && <InputError error={error} />}
    </div>
  );
};

export default ToggleInput;
